// 自定义指令全局文件
import Vue from "vue";
//滚动条
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

/**
 * 自定义加载滚动条指令Y轴
 * 自动判断该更新PerfectScrollbar还是创建它
 * @param {HTMLElement} el - 必填。dom元素
 * @param {object} value - 选填 绑定的入参{scrollx: false, scrolly: true} 默认为显示Y轴，隐藏X轴
 */
const el_scrollBar = (el, value) => {
  //在元素上加点私货，名字随便取，确保不会和已有属性重复即可，我取名叫做_ps_
  if (el._ps_ instanceof PerfectScrollbar) {
    el._ps_.update();
  } else {
    //el上挂一份属性
    el._ps_ = new PerfectScrollbar(el, {
      // 要配什么属性自己看官网，此处不会解释任何其配置项的含义
      suppressScrollX: !value.scrollx,
      suppressScrollY: !value.scrolly,
    });
  }
};

//接着，自定义Vue指令,指令名你自己随便编一个，我们假定它叫scrollBar
Vue.directive("scrollBar", {
  //使用inserted钩子函数（初次创建dom）获取使用自定义指令处的dom
  inserted(el, binding, vnode) {
    // 添加默认参数
    let value = { scrollx: false, scrolly: true };
    if (binding.value) {
      value = JSON.parse(JSON.stringify(binding.value));
    }
    //判断其样式是否存在position 并且position为"fixed", "absolute"或"relative"
    //如果不符合条件，抛个错误。当然你也可以抛个警告然顺便给其position自动加上"relative"
    //为什么要这么做呢，因为PerfectScrollbar实现原理就是对dom注入两个div，一个是x轴一个是y轴，他们两的position都是absolute。
    //对css稍有常识的人都知道，absolute是相对于所有父节点里设置了position属性的最近的一个节点来定位的，为了能够正确定位，我们要给其设置position属性
    const rules = ["fixed", "absolute", "relative", "sticky"];
    if (!rules.includes(window.getComputedStyle(el, null).position)) {
      // console.error(
      //   `perfect-scrollbar所在的容器的position属性必须是以下之一：${rules.join(
      //     "、"
      //   )}`
      // );
    }
    //el上挂一份属性
    el_scrollBar(el, value);
  },
  //更新dom的时候
  componentUpdated(el, binding, vnode, oldVnode) {
    // 添加默认参数
    let value = { scrollx: false, scrolly: true };
    if (binding.value) {
      value = JSON.parse(JSON.stringify(binding.value));
    }
    //vnode.context其实就是vue实例，这里其实无需实例也直接用Vue的静态方法
    //故而也可以写成Vue.nextTick
    vnode.context.$nextTick(() => {
      el_scrollBar(el, value);
    });
  },
});

/**
 * 自定义加载滚动条指令Y轴
 * 自动判断该更新PerfectScrollbar还是创建它
 * @param {HTMLElement} el - 必填。dom元素
 */
const el_scrollBarX = (el) => {
  //在元素上加点私货，名字随便取，确保不会和已有属性重复即可，我取名叫做_ps_
  if (el._ps_ instanceof PerfectScrollbar) {
    el._ps_.update();
  } else {
    //el上挂一份属性
    el._ps_ = new PerfectScrollbar(el, {
      // 要配什么属性自己看官网，此处不会解释任何其配置项的含义
      suppressScrollY: true,
    });
  }
};

//接着，自定义Vue指令,指令名你自己随便编一个，我们假定它叫scrollBarY
Vue.directive("scrollBarX", {
  //使用inserted钩子函数（初次创建dom）获取使用自定义指令处的dom
  inserted(el, binding, vnode) {
    //判断其样式是否存在position 并且position为"fixed", "absolute"或"relative"
    //如果不符合条件，抛个错误。当然你也可以抛个警告然顺便给其position自动加上"relative"
    //为什么要这么做呢，因为PerfectScrollbar实现原理就是对dom注入两个div，一个是x轴一个是y轴，他们两的position都是absolute。
    //对css稍有常识的人都知道，absolute是相对于所有父节点里设置了position属性的最近的一个节点来定位的，为了能够正确定位，我们要给其设置position属性
    const rules = ["fixed", "absolute", "relative", "sticky"];
    if (!rules.includes(window.getComputedStyle(el, null).position)) {
      // console.error(
      //   `perfect-scrollbar所在的容器的position属性必须是以下之一：${rules.join(
      //     "、"
      //   )}`
      // );
    }
    //el上挂一份属性
    el_scrollBarX(el);
  },
  //更新dom的时候
  componentUpdated(el, binding, vnode, oldVnode) {
    //vnode.context其实就是vue实例，这里其实无需实例也直接用Vue的静态方法
    //故而也可以写成Vue.nextTick
    vnode.context.$nextTick(() => {
      el_scrollBarX(el);
    });
  },
});

// 阻止输入表情
const findEle = (parent, type) => {
  return parent.tagName.toLowerCase() === type
    ? parent
    : parent.querySelector(type);
};
const trigger = (el, type) => {
  // 给元素绑定事件
  const e = document.createEvent("HTMLEvents");
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
};

Vue.directive("emoji", {
  // el：指令所绑定的元素，可以用来直接操作 DOM。
  // vnode：Vue 编译生成的虚拟节点
  bind: function (el, binding, vnode) {
    // 指令第一次绑定到元素时调用
    // 判断是否是emoji图标
    const isEmoji = (char) => {
      // 表情都是2个字符
      return char.length > 1;
    };

    const emoji2empty = (str) => {
      // emoji图标都替换成空字符串‘’
      return Array.from(str)
        .filter((c) => !isEmoji(c))
        .join("");
    };
    let $inp = findEle(el, "input") || findEle(el, "textarea"); // 判断绑定元素是否是input输入框或者富文本输入框
    el.$inp = $inp;
    $inp.handle = function () {
      let val = $inp.value;
      $inp.value = emoji2empty(val); // 监听输入框的emoji图标转换成空
      trigger($inp, "input");
    };
    $inp.addEventListener("keyup", $inp.handle); // el添加键盘监听事件keyup
    $inp.addEventListener("blur", $inp.handle); // el添加键盘失焦事件blur
  },
  unbind: function (el) {
    // 只调用一次，指令与元素解绑时调用。
    el.$inp.removeEventListener("keyup", el.$inp.handle);
    el.$inp.removeEventListener("blur", el.$inp.handle);
  },
});
